// 'newslist': config.rootUrl + 'w/newslist',
// 'newsmodel': config.rootUrl + 'w/newsmodel',
// 'partner': config.rootUrl + 'w/cooperator',//获取合作伙伴
import axios from 'axios'
import { config } from './httpurl'
import qs from 'qs'

// 获取新闻
export const getNews = (params) => {
  return axios({
    url: 'https://api.obtdata.com/orbita_cloud/platform/cooperation/company-news/page',
    method: 'GET',
    params
  })
}

// 获取新闻详情
export const getNewsDetail = (id) => {
  return axios({
    method: 'GET',
    url: 'https://api.obtdata.com/orbita_cloud/platform/cooperation/company-news/details/' + id,
  })
}

// 获取合作伙伴
export const getNewsmodel = (params) => {
  return axios({
    url: config.rootUrl + 'w/newsmodel',
    method: 'GET',
    params
  })
}

// 获取合作伙伴
export const getCooperator = () => {
  return axios({
    // url: config.rootUrl + 'cooperator/cooperation-partner',
    // http://localhost:8080/api/orbita_cloud/platform/cooperator/cooperation-partner
    url: 'https://api.obtdata.com/orbita_cloud/platform/cooperation/cooperation-partner',
    method: 'GET',
  })
}

/**
 * 获取联系客服
 * @returns {Promise}
 */
export const getService = () => {
  return axios({
    method: 'GET',
    url: 'https://api.obtdata.com/orbita_cloud/platform/cooperation/customer-service',
  })
}